import { render, staticRenderFns } from "./OnHoldList.vue?vue&type=template&id=5a84f9f4&"
import script from "./OnHoldList.vue?vue&type=script&lang=js&"
export * from "./OnHoldList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports